import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  Grid,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  Chip,
  Modal,
  IconButton,
  Link,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { makeStyles } from "@mui/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DataGrid } from "@mui/x-data-grid";
import { Close } from "@mui/icons-material";
import { showLoader, hideLoader } from "../../redux/loader/actions";
import { showSnackbar } from "../../redux/snackbar/actions";
import { useDispatch } from "react-redux";
import enquiryApi from "../../services/enquiry";
import CustomDatagrid from "../../components/datagrid";
import moment from "moment";
const useStyles = makeStyles({
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginBottom: "10px",
    marginRight: "15px",
  },
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
  modalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    backgroundColor: "#fff",
    boxShadow: 24,
    padding: "20px",
    borderRadius: "8px",
    outline: "none",
  },
});
const Communication = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const planOptions = ["Basic Plan", "Premium Plan", "Enterprise Plan"];
  const frequencyOptions = [
    "Monthly",
    "Quaterly",
    "Halfyearly",
    "Yearly",
    "Unlimited",
  ];
  const creditOptions = ["1 Credit", "5 Credits", "10 Credits"];

  const [formData, setFormData] = useState({
    communicationType: "",
    plan: "",
    frequency: "",
    perCredit: "",
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [comment, setComment] = useState();
  const [error, setError] = useState("");
  const [enquiryData, setEnquiryData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [rowCount, setRowCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [status, setStatus] = useState("");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [searchData, setSearchData] = useState({});

  const handleChange = (e) => {
    const value = e.target.value;
    setComment(value);

    // Validation: required & minimum 10 characters
    if (!value) {
      setError("Comment is required");
    } else if (value.length < 10) {
      setError("Comment must be at least 10 characters");
    } else {
      setError("");
    }
  };

  const handleOpenModal = (row) => {
    setSelectedRow(row);
    setOpenModal(true);
    setComment(row.comment || ""); // Ensure comment resets correctly
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalText("");
    setSelectedRow(null);
    setComment();
  };

  const [expandedRows, setExpandedRows] = useState({});

  const handleSearch = () => {
    setSearchData({
      from: moment(dateFrom).utc().startOf("day").toISOString(),
      to: moment(dateTo).utc().endOf("day").toISOString(),
      search: searchQuery,
      status: status,
    });
  };
  const handleReset = () => {
    setSearchData({});
    setDateFrom(null);
    setDateTo(null);
    setSearchQuery();
    setStatus();
  };

  const toggleExpanded = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getEnquirylist = useCallback(() => {
    dispatch(showLoader());
    const onSuccess = (res) => {
      setEnquiryData(res?.data?.data?.data);
      setRowCount(res?.data?.data?.pagination?.totalItems);
      dispatch(hideLoader());
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
    };
    enquiryApi
      .getAllEnquiry(
        paginationModel.page + 1,
        paginationModel.pageSize,
        searchData
      )
      .then(onSuccess, onFailure);
  }, [paginationModel, searchData]);

  const updateStatus = (id, status) => {
    const data = {
      enquiry_status: status,
    };
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      getEnquirylist();
      dispatch(
        showSnackbar({
          message: res?.data?.msg,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.msg,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    enquiryApi?.updateStatusEnquiry(id, data).then(onSuccess, onFailure);
  };
  const resolveStatus = (id) => {
    const data = {
      comment: comment,
      enquiry_status: "resolved",
    };
    dispatch(showLoader());
    const onSuccess = (res) => {
      getEnquirylist();
      handleCloseModal();
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: res?.data?.msg,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        })
      );
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.msg,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    enquiryApi?.updateStatusEnquiry(id, data).then(onSuccess, onFailure);
  };

  const enquiryListRows = Array.isArray(enquiryData)
    ? enquiryData.map((data, index) => ({
        id: index + 1,
        // sno_id: paginationModel.page * paginationModel.pageSize + index + 1,
        enquire_id: data?.enquiry_code,
        name: data?.name,
        email: data?.email,
        phone: data?.mobile_number,
        subject: data?.subject,
        message: data?.message,
        status: data?.enquiry_status,
        uuid: data?.enquiry_uuid,
        comment: data?.comment ? data?.comment : "-",
      }))
    : [];

  useEffect(() => {
    getEnquirylist();
  }, [getEnquirylist, paginationModel.page, paginationModel.pageSize]);

  const columns = [
    {
      field: "id",
      headerName: "S.No",
      align: "center",
      headerAlign: "left",
      width: 80,
    },
    {
      field: "enquire_id",
      headerName: "Enquiry ID",
      align: "center",
      headerAlign: "left",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Name",
      align: "center",
      headerAlign: "left",
      flex: 1,
      renderCell: (params) => {
        const capitalizedValue = params.value
          ? params.value.charAt(0).toUpperCase() + params.value.slice(1)
          : "";
        return <span>{capitalizedValue}</span>;
      },
    },
    {
      field: "email",
      headerName: "Email",
      align: "center",
      headerAlign: "left",
      flex: 1,
      renderCell: (params) => {
        const capitalizedValue = params.value
          ? params.value.charAt(0).toUpperCase() + params.value.slice(1)
          : "";
        return <span>{capitalizedValue}</span>;
      },
    },
    {
      field: "phone",
      headerName: "Phone Number",
      align: "center",
      headerAlign: "left",
      flex: 1,
      renderCell: (params) => {
        const capitalizedValue = params.value
          ? params.value.charAt(0).toUpperCase() + params.value.slice(1)
          : "";
        return <span>{capitalizedValue}</span>;
      },
    },
    {
      field: "subject",
      headerName: "Subject",
      align: "center",
      headerAlign: "left",
      flex: 1,
      width: 150,
      renderCell: (params) => {
        const capitalizedValue = params.value
          ? params.value.charAt(0).toUpperCase() + params.value.slice(1)
          : "";
        return <span>{capitalizedValue}</span>;
      },
    },
    {
      field: "message",
      headerName: "Message",
      flex: 2,
      renderCell: (params) => {
        const message = params.row.message || "";
        const wordLimit = 20;
        const words = message.split(" ");
        const shouldShowReadMore = words.length > wordLimit;
        const isExpanded = expandedRows[params.id] || false;

        const displayMessage = isExpanded
          ? message
          : shouldShowReadMore
          ? words.slice(0, wordLimit).join(" ") + "..."
          : message;

        return (
          <Box sx={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            <Typography variant="body2">
              {displayMessage}
              {shouldShowReadMore && (
                <Link
                  component="button"
                  onClick={() => toggleExpanded(params.id)}
                  sx={{
                    color: "#a00",
                    cursor: "pointer",
                    marginLeft: "5px",
                    textDecoration: "none",
                  }}
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </Link>
              )}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "comment",
      headerName: "Comments",
      flex: 1,
      renderCell: (params) => {
        const comment = params.row.comment || "";
        const wordLimit = 15;
        const words = comment.split(" ");
        const shouldShowReadMore = words.length > wordLimit;
        const isExpanded = expandedRows[params.id] || false;

        const displayComment = isExpanded
          ? comment
          : shouldShowReadMore
          ? words.slice(0, wordLimit).join(" ") + "..."
          : comment;

        return (
          <Box sx={{ whiteSpace: "normal", wordBreak: "break-word" }}>
            <Typography variant="body2">
              {displayComment}
              {shouldShowReadMore && (
                <Link
                  component="button"
                  onClick={() => toggleExpanded(params.id)}
                  sx={{
                    color: "#a00",
                    cursor: "pointer",
                    marginLeft: "5px",
                    textDecoration: "none",
                  }}
                >
                  {isExpanded ? "Read Less" : "Read More"}
                </Link>
              )}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "left",
      flex: 1,
      width: 75,
      renderCell: (params) => {
        const capitalizedValue = params.value
          ? params.value.charAt(0).toUpperCase() + params.value.slice(1)
          : "";
        return <span>{capitalizedValue}</span>;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      width: 250,
      renderCell: (params) => {
        const { status, uuid } = params.row;

        return (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
              width: "100%",
              height: "100%",
              padding: "5px",
              "@media (max-width: 600px)": {
                gap: "4px",
                "& .MuiChip-root": {
                  fontSize: "12px",
                  padding: "2px 4px",
                },
              },
            }}
          >
            <Chip
              label="Unread"
              color="primary"
              size="small"
              onClick={() => updateStatus(uuid, "unread")}
              clickable
              sx={{ cursor: "pointer" }}
              variant="outlined"
              disabled={
                status.toLowerCase() === "unread" ||
                status.toLowerCase() === "resolved"
              }
            />
            <Chip
              label="Pending"
              color="warning"
              size="small"
              onClick={() => updateStatus(uuid, "pending")}
              clickable
              sx={{ cursor: "pointer" }}
              variant="outlined"
              disabled={
                status.toLowerCase() === "pending" ||
                status.toLowerCase() === "resolved"
              }
            />
            <Chip
              label="Resolved"
              color="success"
              size="small"
              onClick={() => handleOpenModal(params.row)}
              clickable
              sx={{ cursor: "pointer" }}
              variant="outlined"
              disabled={status.toLowerCase() === "resolved"}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Card elevation={3} sx={{ p: 3, mb: 2 }}>
        <Typography
          sx={{ mb: 2, color: "#a00", fontSize: "20px", fontWeight: "600" }}
        >
          Enquiry
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Create Date From"
                value={dateFrom}
                onChange={(value) => setDateFrom(value)}
                sx={{ width: "100%" }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Create Date To"
                value={dateTo}
                onChange={(value) => setDateTo(value)}
                sx={{ width: "100%" }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel shrink>Status</InputLabel>
              <Select
                name="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                displayEmpty
                label="Status"
              >
                <MenuItem value="">None</MenuItem>
                <MenuItem value="unread">Unread</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="resolved">Resolved</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Advance Search"
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              name="search"
            />
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="flex-end"
            sx={{ mt: 2, gap: 2 }}
          >
            <Button variant="outlined" onClick={handleReset}>
              Reset
            </Button>
            <Button
              className={classes.animatedButton}
              variant="contained"
              size="small"
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </Card>
      <Card elevation={3} sx={{ p: 2, mt: 2 }}>
        <Box sx={{ width: "100%" }}>
          {/* <DataGrid
            rows={enquiryListRows}
            columns={columns}
            pageSize={5} autoHeight
            getRowHeight={() => 'auto'}
            rowsPerPageOptions={[5, 10, 20]}
          /> */}
          <CustomDatagrid
            rows={enquiryListRows}
            columns={columns}
            getRowId={(row) => row.id}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            rowCount={rowCount}
            disableSelectionOnClick={true}
            checkboxSelection={false}
            pagination
            pageSizeOptions={[5, 10, 20]}
            sx={{
              "& .MuiDataGrid-cell": {
                py: 1,
                whiteSpace: "normal",
                wordBreak: "break-word",
              },
            }}
          />
        </Box>
      </Card>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box className={classes.modalBox}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" sx={{ color: "#a00", fontWeight: "bold" }}>
              Resolved Comment
            </Typography>
            <IconButton onClick={handleCloseModal}>
              <Close />
            </IconButton>
          </Box>

          <TextField
            fullWidth
            label="Comment"
            name="comment"
            variant="outlined"
            multiline
            minRows={5}
            value={comment}
            onChange={handleChange}
            error={Boolean(error)}
            helperText={error}
            sx={{ mb: 2 }}
          />
          <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.animatedButton}
              onClick={() => resolveStatus(selectedRow?.uuid)} // Corrected: Wrapped in an arrow function
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Communication;
